import ServicePage from '@/pages/services/ServicePage';

const content = {
  eyebrow: 'Desarrollo de Software',
  title: 'Software a medida, preparado para crecer.',
  subtitle:
    'Construimos plataformas digitales desde cero y modernizamos sistemas existentes, diseñando arquitecturas preparadas para escalar y mantenerse en el tiempo.',
  tags: ['SaaS', 'Web', 'Mobile', 'APIs', 'Microservicios', 'Multi-tenant'],
  blocks: [
    {
      icon: 'ri-cloud-line',
      title: 'Plataformas SaaS',
      desc: 'Desarrollamos productos SaaS comerciales, multi-tenant y listos para escalar.',
    },
    {
      icon: 'ri-building-2-line',
      title: 'Sistemas empresariales',
      desc: 'Sistemas internos y portales administrativos que resuelven operaciones reales.',
    },
    {
      icon: 'ri-global-line',
      title: 'Aplicaciones web',
      desc: 'Interfaces modernas, rápidas y centradas en la experiencia del usuario.',
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Aplicaciones móviles',
      desc: 'Apps para iOS y Android con React Native, conectadas a tus servicios.',
    },
    {
      icon: 'ri-links-line',
      title: 'APIs y microservicios',
      desc: 'Diseño y desarrollo de APIs robustas y arquitecturas desacopladas.',
    },
    {
      icon: 'ri-refresh-line',
      title: 'Modernización de sistemas',
      desc: 'Evolucionamos aplicaciones legacy hacia arquitecturas modernas y mantenibles.',
      items: ['Legacy', 'Refactoring', 'Migraciones'],
    },
  ],
  highlightTitle: 'Desde una idea hasta un producto en producción.',
  highlightDesc:
    'Acompañamos todo el ciclo: arquitectura, desarrollo, integraciones, infraestructura y puesta en producción.',
};

export default function DesarrolloSoftware() {
  return <ServicePage content={content} />;
}